import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '../../assets/img/logo.svg'


const _hoisted_1 = { class: "startp-nav" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "navbar navbar-expand-md navbar-light" }
const _hoisted_4 = {
  class: "navbar-brand",
  href: "/"
}
const _hoisted_5 = {
  class: "collapse navbar-collapse",
  id: "navbarSupportedContent"
}
const _hoisted_6 = { class: "navbar-nav nav ml-auto" }
const _hoisted_7 = { class: "nav-item" }
const _hoisted_8 = { class: "nav-item" }
const _hoisted_9 = { class: "nav-item" }
const _hoisted_10 = { class: "nav-link" }
const _hoisted_11 = { class: "dropdown_menu" }
const _hoisted_12 = { class: "nav-item" }
const _hoisted_13 = { class: "nav-item" }
const _hoisted_14 = { class: "nav-item" }
const _hoisted_15 = { class: "nav-item" }
const _hoisted_16 = {
  key: 0,
  class: "nav-item"
}
const _hoisted_17 = {
  key: 1,
  class: "nav-item"
}

import { ref, onMounted, computed } from 'vue'
import { Collapse } from 'bootstrap'
import { useAuthStore } from '../../store/user'
import { useRouter } from 'vue-router'


export default /*@__PURE__*/_defineComponent({
  __name: 'HeaderComponent',
  setup(__props) {

const userStore = useAuthStore()
const router = useRouter()
const isSticky = ref(false)
const isMobile = ref(false)
const isShrunk = ref(false)
onMounted(() => {
  window.addEventListener('scroll', () => {
    isShrunk.value = window.scrollY > 50 // Shrink when scrolled 50px

    const scrollPos = window.scrollY
    // eslint-disable-next-line no-console
    if (scrollPos >= 100) {
      isSticky.value = true
    } else {
      isSticky.value = false
    }
  })
  window.addEventListener('resize', handleResize)
  handleResize()
  window.addEventListener('DOMContentLoaded', function () {
    const btn = document.getElementById('collapseBtn')
    const element = document.getElementById('navbarSupportedContent')

    const myCollapse = new Collapse(element!)

    btn?.addEventListener('click', function () {
      myCollapse.toggle()
    })
  })
})

const connectedUser = computed(() => {
  return userStore.userData
})

const logout = async () => {
  await userStore.logout()
  router.push('/')
}

const handleResize = () => {
  if (window.innerWidth < 992) {
    isMobile.value = true
  } else isMobile.value = false
}


return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_vue_feather = _resolveComponent("vue-feather")!

  return (_openBlock(), _createElementBlock("header", {
    id: "header",
    class: _normalizeClass(['headroom', { 'is-sticky': isSticky.value }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("nav", _hoisted_3, [
          _createElementVNode("a", _hoisted_4, [
            _createElementVNode("img", {
              src: _imports_0,
              class: _normalizeClass(["navbarbrand", { 'navbar-shrink': isShrunk.value }]),
              alt: "IT+ Code Lab"
            }, null, 2)
          ]),
          _cache[9] || (_cache[9] = _createElementVNode("button", {
            class: "navbar-toggler",
            type: "button",
            "aria-controls": "navbarSupportedContent",
            id: "collapseBtn",
            "aria-expanded": "false",
            "aria-label": "Toggle navigation"
          }, [
            _createElementVNode("span", { class: "navbar-toggler-icon" })
          ], -1)),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("ul", _hoisted_6, [
              _createElementVNode("li", _hoisted_7, [
                _createVNode(_component_router_link, {
                  to: "/",
                  class: "nav-link"
                }, {
                  default: _withCtx(() => _cache[1] || (_cache[1] = [
                    _createTextVNode("Acceuil")
                  ])),
                  _: 1
                })
              ]),
              _createElementVNode("li", _hoisted_8, [
                _createVNode(_component_router_link, {
                  to: "/a-propos",
                  class: "nav-link"
                }, {
                  default: _withCtx(() => _cache[2] || (_cache[2] = [
                    _createTextVNode("A propos de nous")
                  ])),
                  _: 1
                })
              ]),
              _createElementVNode("li", _hoisted_9, [
                _createElementVNode("a", _hoisted_10, [
                  _cache[3] || (_cache[3] = _createTextVNode("Programmes ")),
                  _createVNode(_component_vue_feather, { type: "chevron-down" })
                ]),
                _createElementVNode("ul", _hoisted_11, [
                  _createElementVNode("li", _hoisted_12, [
                    _createVNode(_component_router_link, {
                      to: "/cours-programmation",
                      class: "nav-link"
                    }, {
                      default: _withCtx(() => _cache[4] || (_cache[4] = [
                        _createTextVNode("Developpement")
                      ])),
                      _: 1
                    })
                  ]),
                  _createElementVNode("li", _hoisted_13, [
                    _createVNode(_component_router_link, {
                      to: "/cours-reseaux-systemes",
                      class: "nav-link"
                    }, {
                      default: _withCtx(() => _cache[5] || (_cache[5] = [
                        _createTextVNode("Systemes et réseaux")
                      ])),
                      _: 1
                    })
                  ])
                ])
              ]),
              _createElementVNode("li", _hoisted_14, [
                _createVNode(_component_router_link, {
                  to: "/contact",
                  class: "nav-link"
                }, {
                  default: _withCtx(() => _cache[6] || (_cache[6] = [
                    _createTextVNode("Contact")
                  ])),
                  _: 1
                })
              ]),
              _createElementVNode("li", _hoisted_15, [
                _createVNode(_component_router_link, {
                  to: "/enroll",
                  class: "nav-link"
                }, {
                  default: _withCtx(() => _cache[7] || (_cache[7] = [
                    _createTextVNode("S'inscrire à une formation")
                  ])),
                  _: 1
                })
              ]),
              (connectedUser.value)
                ? (_openBlock(), _createElementBlock("li", _hoisted_16, [
                    _createVNode(_component_router_link, {
                      to: "/new_course",
                      class: "nav-link"
                    }, {
                      default: _withCtx(() => _cache[8] || (_cache[8] = [
                        _createTextVNode("Ajouter un cours")
                      ])),
                      _: 1
                    })
                  ]))
                : _createCommentVNode("", true),
              (connectedUser.value)
                ? (_openBlock(), _createElementBlock("li", _hoisted_17, [
                    _createElementVNode("button", {
                      class: "btn btn-danger",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (logout()))
                    }, " Deconnecter ")
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ])
    ])
  ], 2))
}
}

})